module.exports = __webpack_public_path__ + "img/spinner.5e858ca1.gif";